var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "367px",
    viewBox: "0 0 89 367",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Man") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8335764,345 L69.2180553,347.237568 C79.0199218,345.911899 83.9409821,344.183509 87.1210538,347.548899 L88.0167069,348.501975 C89.204202,350.845998 87.3424511,354.602059 83.7397117,356.000037 L57.0814526,366.62246 C51.8685503,367.853725 46.4040601,366.062063 46.3738695,361.413184 C46.3738695,361.413184 46.4040601,348.41661 48.7790503,347.901407 C53.5592213,346.867988 51.66728,345.985213 55.8335764,345",
    id: "Fill-120",
    fill: "#223A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3740674,350.808919 L49.5873378,333 L62.3738695,333.160632 L62.1702932,350.970561 C62.1024344,356.449218 49.3159027,356.288586 49.3740674,350.808919 Z",
    id: "Fill-121",
    fill: "#596FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.939869521,242.015 L9.58486952,183.393 C8.84686952,174.395 10.5168695,167.242 14.2308695,154.077 L47.6278695,173.738 L17.8548695,262.223 C14.2308695,268.840666 -4.34674238,265.031107 0.939869521,242.015 Z",
    id: "Fill-124-Copy",
    fill: "#223A6B"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-116",
    fill: "#223A6B",
    points: "22.1248695 203.526 59.9078695 210.118 59.9078695 170.66 22.1248695 164.068 22.1248695 203.526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4378695,334.875 C60.8278695,341.114 49.3878695,341.011 46.9278695,336.783 C45.4978695,311.845 37.0778695,285.291 46.6978695,251.005 L35.5478695,147 L82.0178695,156.288 L71.7078695,266.083 L65.4378695,334.875",
    id: "Fill-122",
    fill: "#223A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6890475,38.070973 C70.4568366,47.52829 58.7350617,48.7042613 53.8476089,40.6342467 C48.970296,32.5642321 49.2643543,18.3565168 54.5067052,8.89919986 C59.7389161,-0.558117109 67.9421306,-1.6825196 72.8194435,6.38749502 C77.6967564,14.4575096 80.9313984,28.6146672 75.6890475,38.070973",
    id: "Fill-125",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4365591,61.2599629 L40.411333,60.7858762 C36.9336051,59.1842052 35.4058172,55.0377012 37.014015,51.5717572 L46.0701792,32.0269599 C47.6683258,28.5610158 51.8295378,27.0355193 55.3072657,28.6361881 L56.3324918,29.111277 C59.8102197,30.7119458 61.3380076,34.8584498 59.739861,38.3243938 L53.7995802,58.3803627 C52.2014335,61.8463068 44.914287,62.8616339 41.4365591,61.2599629",
    id: "Fill-126",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4358434,29.5275823 C38.4358434,29.5275823 36.8844829,36.8355004 49.3054406,41.5428035 C58.6841199,45.0962775 60.1750378,26.7559926 70.2286596,27.1779302 C83.8181746,27.7478458 85.0371007,14.8777511 82.0048961,8.91163434 C78.9626177,2.94651743 71.7598726,1.79968721 62.8546605,0.429889998 C53.4457598,-1.01889552 39.3122614,-0.455978856 38.4358434,29.5275823",
    id: "Fill-127",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8104968,31.6752061 C65.6146805,33.8501461 62.8690863,34.6401639 60.6974839,33.4379213 C58.5258815,32.2366352 57.7318594,29.4993096 58.9372423,27.3243696 C60.1330586,25.1494296 62.8786528,24.3603683 65.0502552,25.5616544 C67.2218576,26.7629405 68.0158796,29.5002661 66.8104968,31.6752061",
    id: "Fill-128",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37386952,163.342439 C9.5073836,137.044098 13.457144,119.861874 12.1753009,97.1267408 C12.6714012,53.6802731 18.0964337,51.8209464 27.6736755,49.0680598 L37.2549262,48 C40.2215059,48.5666233 42.9776189,49.9365479 45.9241541,50.6566108 C58.2314511,53.6702444 66.1289674,54.3421694 74.9685732,59.133897 C82.846045,63.4011219 83.3070675,74.8067975 83.2870231,84.3611693 C85.4117356,112.364394 85.9729804,154.520164 86.3738695,168.343767 C81.8939333,188.133462 15.86749,176.73982 8.37386952,163.342439",
    id: "Fill-129",
    fill: "#B1BCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8568241,44.6830355 L56.3738695,42 C56.3738695,42 57.7848544,44.3144706 61.3738695,44.6752558 C61.3738695,44.6752558 59.0443241,45.4007159 56.8568241,44.6830355",
    id: "Fill-130",
    fill: "#BA4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3738695,88 L81.0569296,95.766697 C72.4714495,129.872845 76.4495916,164.449429 62.3738695,179 C70.9897946,178.976029 78.8851888,177.860365 84.7204737,173.634427 C85.0350717,173.672381 87.7243769,171.315205 88.1201615,167.062299 L88.3738695,88",
    id: "Fill-131",
    fill: "#8A9EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7110598,47.2314947 C35.7110598,47.2314947 33.4163809,53.8041772 40.7992609,56.2486584 C48.1721639,58.694186 60.3738695,54.3870436 60.3738695,54.3870436 C60.3738695,54.3870436 52.2527016,45.4651059 35.7110598,47.2314947",
    id: "Fill-132",
    fill: "#223A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3944578,32.9125819 L63.3944578,32.9125819 C62.5963162,32.6328201 62.1726113,31.7646932 62.4682193,30.9830907 L64.5374754,21.2327668 C64.8232298,20.4511642 66.5476098,21.8653554 67.3457514,22.1451172 C68.1537467,22.424879 70.6368539,22.8411568 70.3510995,23.621798 L65.3750314,32.0002315 C65.089277,32.7808727 64.202453,33.1913823 63.3944578,32.9125819",
    id: "Fill-133",
    fill: "#27427A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/Man.70dcc1ae25162707a5b3428963dd9f77.svg";
export { ForwardRef as ReactComponent };